import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  home: null,
  about: null,
  committees: null,
  meetings: null,
  affiliates: null,
  contactus: null,
  patients: null,
  membership: null,
  resources: null,
  fiesta: null,
  privacypolicy: null,
  cancelpolicy: null,
  currentPage: null,
  loading: false,
  lastUpdated: null,
  error: null,
};

const pageContentsSlice = createSlice({
  name: "pageContents",
  initialState,
  reducers: {
    setPageContent: (state, action) => {
      const { page, content } = action.payload;
      log.debug(`Setting page content for ${page}:`, content);

      state[page] = content;
      state.lastUpdated = new Date().toISOString();
      state.currentPage = page;
      log.debug(`Updated ${page} in Redux store`);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearPageContent: (state, action) => {
      const page = action.payload;
      state[page] = null;
    },
    clearAllPageContent: (state) => {
      // Reset all content fields to null without changing property names
      Object.keys(initialState).forEach((key) => {
        if (
          key !== "currentPage" &&
          key !== "loading" &&
          key !== "lastUpdated" &&
          key !== "error"
        ) {
          state[key] = null;
        }
      });
      state.currentPage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase("FETCH_PAGE_CONTENT_REQUEST", (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase("FETCH_PAGE_CONTENT_SUCCESS", (state, action) => {
        state.loading = false;
        // REVERTED: Use original property naming convention
        if (action.payload?.page && action.payload?.content) {
          state[action.payload.page] = action.payload.content;
          log.debug(
            `Updated ${action.payload.page} via FETCH_PAGE_CONTENT_SUCCESS`,
          );
        }
        state.lastUpdated = new Date().toISOString();
      })
      .addCase("FETCH_PAGE_CONTENT_FAILURE", (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setPageContent,
  setLoading,
  setError,
  clearPageContent,
  clearAllPageContent,
} = pageContentsSlice.actions;

export default pageContentsSlice.reducer;
